import { useNavigate } from "react-router-dom";
import DashboardLayout from "../dashboard/DashboardLayout";
import ResultsHistoryDetails from "./ResultsHistoryDetails";


export default function ResultsHistoryDetailsPage() {
    const navigate = useNavigate()
    return (
        <DashboardLayout>
            <ResultsHistoryDetails
            onBack={()=>{navigate('/results')}}
            />
        </DashboardLayout>
    );
}